document.addEventListener("DOMContentLoaded", () => {

    const form = document.getElementById("bulkOrderForm");

    if (!form) return;

    form.addEventListener("submit", function () {

        const btn = form.querySelector(".bulk-submit");

        if (btn) {

            btn.disabled = true;
            btn.innerHTML = "Submitting...";

        }

    });

    window.addEventListener("pageshow", function () {

        const btn = document.querySelector(".bulk-submit");

        if(btn){

            btn.disabled = false;

            btn.innerHTML = "Submit Inquiry";

        }

    });

});